<template>
<!--<div class="page" v-if="account()">-->
<div class="page" v-if="document_data">
  <table style="width:718px; border:0; border-spacing: 0px; border-collapse: collapse" >
      <tr style="height: 1px"><td width="76"/><td width="317"/><td width="57"/><td width="57"/><td width="19"/><td width="4"/><td width="23"/><td width="19"/><td width="19"/><td width="10"/><td width="5"/><td width="8"/><td width="18"/><td width="87"/><td width="1"/></tr>
      <tr style="height:26px">
        <td colspan="7" rowspan="2" class="normaltext">
          <template v-if="document_data.region.toLowerCase() === 'astana'">Филиал ТОО "BTcom infocommunications" в г. Астана, <br>Республика Казахстан, 010000, г. Астана, пр.Кабанбай батыра, д.11<br>ИИК KZ206017131000022031, АО «Народный Банк Казахстана», БИК HSBKKZKX, КНП 852, Кбе 17.<br>БИН  170441029764</template>
          <template v-if="document_data.region.toLowerCase() === 'almaty'">ТОО &quot;BTcom infocommunications&quot;, <br>050059, Республика Казахстан, г. Алматы, пр. Аль-Фараби, д. 5<br>ИИК KZ206017131000022031, АО «Народный Банк Казахстана», БИК HSBKKZKX, КНП 852, Кбе 17.<br>БИН  031040000631</template>
        </td><td colspan="7" class="print_date">Дата формирования: <br>{{document_data.create_date}}</td>
      </tr>
      <tr style="height:4px">
      <td/><td/><td/><td/><td/><td/><td/><td/>
      </tr>
      <tr style="height:18px">
      <td colspan="6" rowspan="2">&nbsp;</td><td colspan="9" class="s4">Квитанция № {{ document_data.number }}</td>
      </tr>
      <tr style="height:2px">
      <td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td colspan="4" rowspan="2" class="s1" style="font-size:1px"></td><td/>
      </tr>
      <tr style="height:35px">
      <td colspan="9" rowspan="2" class="sAbonent">Лицевой счет: {{ document_data.account_id }}</td><td/><td/>
<!--      <td colspan="9" rowspan="2" class="sAbonent">{{ document().contragent_name }}{{ document().contragent_name }}<br>Лицевой счет: {{ document().account_id }}</td><td/><td/>-->
      </tr>
      <tr style="height:3px">
      <td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/><td/>
      </tr>
      <tr style="height:20px">
      <td colspan="13" class="sAttr"><b>Адрес:</b> {{ document_data.contract.address }}</td><td/><td/>
      </tr>
      <tr style="height:18px">
      <td colspan="15" class="sAttrItalic">Назначение платежа: Оплата услуг по ЛС {{ document_data.account_id }} за {{ document_data.period_name }}г.</td>
      </tr>
      <tr style="height:15px">
      <td class="s5">Дата</td><td class="s20">Наименование<br>(работ, услуг)</td><td class="s20">Ед. изм.</td><td class="s20">Кол-во</td><td colspan="8" class="s20">Начислено</td><td colspan="3" class="s20">Оплачено</td>
      </tr>
      <tr style="height:18px">
      <td colspan="15" class="s8">ЛС: {{ document_data.account_id }} </td>
      </tr>
      <tr style="height:15px">
      <td class="s9"></td><td class="s21">Входящее сальдо ( долг за прошлые периоды )</td><td class="s20" style="font-size:1px">&nbsp;</td><td class="s20" style="font-size:1px">&nbsp;</td><td colspan="8" class="s22">{{document_data.balance_in}}</td><td colspan="3" class="s22">{{document_data.prepay_amount}}</td>
      </tr>
      <tr style="height:15px" v-for="(charge, index) in document_data.charges" :key="'main_charge_'+index">
        <td class="s23">{{ charge.service_date }}</td><td class="s24 normaltext">{{ charge.service_name }}</td><td class="s25">услуга</td><td class="s25">{{ charge.quantity }}</td><td colspan="8" class="s26">{{ charge.final_amount }}</td><td colspan="3" class="s26">0.00</td>
      </tr>
      <tr style="height:15px">
      <td class="s27"></td><td class="s28">Итого за период</td><td class="s25" style="font-size:1px">&nbsp;</td><td class="s25" style="font-size:1px">&nbsp;</td><td colspan="8" class="s29">{{document_data.charge}}</td><td colspan="3" class="s29">{{document_data.payments}}</td>
      </tr>
      <tr style="height:15px">
      <td class="s27"></td><td class="s28">Исходящее сальдо ( к оплате ) / Переплата</td><td class="s25" style="font-size:1px">&nbsp;</td><td class="s25" style="font-size:1px">&nbsp;</td><td colspan="8" class="s29">{{document_data.balance_out | balance_out}}</td><td colspan="3" class="s29">{{document_data.balance_out | balance_out_overpay}}</td>
      </tr>
<!--      <tr style="height:15px" v-if="document_data.last_receipt">
      <td class="s27"></td><td class="s28">Оплаты на {{ currentDate() }}</td><td class="s25" style="font-size:1px">&nbsp;</td><td class="s25" style="font-size:1px">&nbsp;</td><td colspan="8" class="s29">0.00</td><td colspan="3" class="s29">{{document_data.current_pays}}</td>
      </tr>-->
      <template v-if="document_data.sub_accounts">
        <tr style="height:18px">
          <td colspan="15" class="s8">ЛС: {{ document_data.sub_accounts.account_id }} {{ document_data.sub_accounts.contract_name }}</td>
        </tr>
        <tr style="height:15px">
          <td class="s9"></td><td class="s21">Входящее сальдо ( долг за прошлые периоды )</td><td class="s20" style="font-size:1px">&nbsp;</td><td class="s20" style="font-size:1px">&nbsp;</td><td colspan="8" class="s22">{{document_data.sub_accounts.balance_in}}</td><td colspan="3" class="s22">{{document_data.sub_accounts.prepay_amount}}</td>
        </tr>
        <tr style="height:15px" v-for="(charge, index) in document_data.sub_accounts.charges" :key="'sub_charge_'+index">
          <td class="s23">{{ charge.service_date }}</td><td class="s24 normaltext">{{ charge.service_name }}</td><td class="s25">услуга</td><td class="s25">{{ charge.quantity }}</td><td colspan="8" class="s26">{{ charge.final_amount }}</td><td colspan="3" class="s26">0.00</td>
        </tr>
        <tr style="height:15px">
          <td class="s27"></td><td class="s28">Итого за период</td><td class="s25" style="font-size:1px">&nbsp;</td><td class="s25" style="font-size:1px">&nbsp;</td><td colspan="8" class="s29">{{document_data.sub_accounts.charge}}</td><td colspan="3" class="s29">{{document_data.sub_accounts.payments}}</td>
        </tr>
        <tr style="height:15px">
          <td class="s27"></td><td class="s28">Исходящее сальдо ( к оплате ) / Переплата</td><td class="s25" style="font-size:1px">&nbsp;</td><td class="s25" style="font-size:1px">&nbsp;</td><td colspan="8" class="s29">{{document_data.sub_accounts.balance_out | balance_out}}</td><td colspan="3" class="s29">{{document_data.sub_accounts.balance_out | balance_out_overpay}}</td>
        </tr>
       <!-- <tr style="height:15px" v-if="document_data.last_receipt">
          <td class="s27"></td><td class="s28">Оплаты на {{ currentDate() }}</td><td class="s25" style="font-size:1px">&nbsp;</td><td class="s25" style="font-size:1px">&nbsp;</td><td colspan="8" class="s29">0.00</td><td colspan="3" class="s29">{{document_data.sub_accounts.current_pays}}</td>
        </tr>-->
      </template>
      <tr style="height:15px">
        <td colspan="5" rowspan="4" class="s15">
          <template v-if="document_data.region.toLowerCase() === 'astana'">По всем вопросам обращайтесь в Контакт-центр по телефонам:<br>8 (7172) 68-89-00 круглосуточно 24/7<br><br><b>Уважаемые абоненты, убедительно просим Вас производить оплату до 25 числа текущего месяца в любых отделениях РКО АО "Народный Банк Казахстана", АО "БанкЦентрКредит", АО "Казпочта", а также посредством сервисов интернет-банкинга  kaspi.kz, StarBanking.kz, my.fortebank.com или терминала "QIWI".В противном случае будет произведено отключение услуг.</b></template>
          <template v-if="document_data.region.toLowerCase() === 'almaty'">По всем вопросам обращайтесь в единый, круглосуточный Контакт-центр по телефонам:<br>2-777-000, 2-777-888 или по e-mail: callcenter@btcom.kz<br><br><b>Уважаемые абоненты, убедительно просим Вас производить оплату до 25 числа текущего месяца в любых РКО АО "Народный Банк Казахстана", АО "Jysan Bank", АО "Bereke Bank", а также посредством сервисов интернет-банкинга Homebank.kz, Smartbank.kz, Kaspi.kz</b></template>
        </td><td colspan="6" class="s16">Всего к оплате:</td><td colspan="4" class="s17">{{document_data.to_pay | balance_out}}</td>
      </tr>
      <tr style="height:15px">
      <td colspan="6" class="s16">Оплачиваю:</td><td colspan="4" rowspan="2" class="s18" style="font-size:1px">&nbsp;</td>
      </tr>
      <tr style="height:7px">
      <td colspan="6" rowspan="2" class="s15" style="font-size:1px">&nbsp;</td>
      </tr>
      <tr style="height:39px">
      <td colspan="4" class="s15" style="font-size:1px">&nbsp;</td>
      </tr>
    </table>
</div>
</template>

<script>
export default {
  name: "ReceiptPrint",
  props: {
    document_data: null
  },
  methods:{
    currentDate: function (){
      const current = new Date();
      // const output = `${current.getDate()}.${current.getMonth()}.${current.getFullYear()} ${current.getHours()}:${current.getMinutes()}:${current.getSeconds()}`;
      const output = current.toLocaleString();
      return output;
    },
    document: function (){
      return this.document_data ? this.document_data : null
    },
  },
  filters: {
    balance_out: function (value) {
      if (value < 0) return '0.00'
      return value
    },
    balance_out_overpay: function (value) {
      console.log('balance_out_overpay', value)
      if (value < 0) return value * -1
      return '0.00'
    }
  }
}
</script>

<style scoped>

.normaltext {
	font-family: Arial;
	font-size: 11px;
	color: #000000; font-style: normal;
	background-color: transparent;
	text-align: Left; vertical-align: Top;
	padding-top: 1px;
	padding-left: 2px;
}
.s1 {
	font-family: Arial;
	font-size: 12px;
	color: #000000; font-style: normal;
	background-color: transparent;
	text-align: Left; vertical-align: Top;
}
.sAttr {
	font-family: Arial;
	font-size: 13px;
	color: #000000; font-style: normal;
	background-color: transparent;
	text-align: Left; vertical-align: Top;
	padding-top: 1px;
	padding-left: 2px;
}
.sAttrItalic {
	font-family: Arial;
	font-size: 13px;
	color: #000000; font-weight: bold; font-style: italic;
	background-color: transparent;
	text-align: Left; vertical-align: Top;
	padding-top: 1px;
	padding-left: 2px;
}

.s4 {
	font-family: Arial;
	font-size: 13px;
	color: #000000; font-style: normal;
	background-color: transparent;
	border-left-color:#000000; border-left-style: solid; border-left-width: 1px;
	border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
	border-top-color:#000000; border-top-style: solid; border-top-width: 1px;
	border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
	text-align: Center; vertical-align: Middle;
}
.s5 {
	font-family: Times New Roman;
	font-size: 11px;
	color: #000000; font-style: normal;
	background-color: transparent;
	border-left-color:#000000; border-left-style: solid; border-left-width: 1px;
	border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
	border-top-color:#000000; border-top-style: solid; border-top-width: 1px;
	border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
	text-align: Center; vertical-align: Top;
	padding-top: 1px;
}
.print_date {
	font-family: Times New Roman;
	font-size: 11px;
	color: #000000; font-style: normal;
	background-color: transparent;
	text-align: Right; vertical-align: Top;
	padding-top: 1px;
	padding-right: 2px;
}
.sAbonent {
	font-family: Arial;
	font-size: 16px;
	color: #000000; font-weight: bold; font-style: normal;
	background-color: transparent;
	text-align: Left; vertical-align: Middle;
	padding-left: 2px;
}
.s8 {
	font-family: Arial;
	font-size: 12px;
	color: #000000; font-weight: bold; font-style: normal;
	background-color: #D8D8D8;
	border-left-color:#000000; border-left-style: solid; border-left-width: 1px;
	border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
	border-top-color:#000000; border-top-style: solid; border-top-width: 1px;
	border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
	text-align: Left; vertical-align: Middle;
	padding-left: 2px;
}
.s9 {
	font-family: Times New Roman;
	font-size: 11px;
	color: #FFFFFF; font-style: normal;
	background-color: transparent;
	border-left-color:#000000; border-left-style: solid; border-left-width: 1px;
	border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
	border-top-color:#000000; border-top-style: solid; border-top-width: 1px;
	border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
	text-align: Center; vertical-align: Top;
	padding-top: 1px;
}
.s15 {
	font-family: Times New Roman;
	font-size: 11px;
	color: #000000; font-style: normal;
	background-color: transparent;
	text-align: Left; vertical-align: Top;
	padding-top: 1px;
	padding-left: 2px;
}
.s16 {
	font-family: Times New Roman;
	font-size: 11px;
	color: #000000; font-weight: bold; font-style: normal;
	background-color: transparent;
	text-align: Left; vertical-align: Top;
	padding-top: 1px;
	padding-left: 2px;
}
.s17 {
	font-family: Times New Roman;
	font-size: 11px;
	color: #000000; font-weight: bold; font-style: normal;
	background-color: transparent;
	text-align: Right; vertical-align: Top;
	padding-top: 1px;
	padding-right: 2px;
}
.s18 {
	font-family: Times New Roman;
	font-size: 11px;
	color: #000000; font-weight: bold; font-style: normal;
	background-color: transparent;
	border-left-color:#000000; border-left-style: solid; border-left-width: 1px;
	border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
	border-top-color:#000000; border-top-style: solid; border-top-width: 1px;
	border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
	text-align: Left; vertical-align: Top;
	padding-top: 1px;
	padding-left: 2px;
}
.s19 {
	font-family: Arial;
	font-size: 13px;
	color: #000000; font-style: normal;
	background-color: transparent;
	border-left-width: 0px;
	border-right-width: 0px;
	border-top-width: 0px;
	border-bottom-color:#000000; border-bottom-style: dotted; border-bottom-width: 1px;
	text-align: Left; vertical-align: Top;
	padding-top: 1px;
	padding-left: 2px;
}
.s20 {
	font-family: Times New Roman;
	font-size: 11px;
	color: #000000; font-style: normal;
	background-color: transparent;
	border-left-width: 0px;
	border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
	border-top-color:#000000; border-top-style: solid; border-top-width: 1px;
	border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
	text-align: Center; vertical-align: Top;
	padding-top: 1px;
}
.s21 {
	font-family: Times New Roman;
	font-size: 11px;
	color: #000000; font-weight: bold; font-style: normal;
	background-color: transparent;
	border-left-width: 0px;
	border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
	border-top-color:#000000; border-top-style: solid; border-top-width: 1px;
	border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
	text-align: Left; vertical-align: Top;
	padding-top: 1px;
	padding-left: 2px;
}
.s22 {
	font-family: Times New Roman;
	font-size: 11px;
	color: #000000; font-weight: bold; font-style: normal;
	background-color: transparent;
	border-left-width: 0px;
	border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
	border-top-color:#000000; border-top-style: solid; border-top-width: 1px;
	border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
	text-align: Right; vertical-align: Top;
	padding-top: 1px;
	padding-right: 2px;
}
.s23 {
	font-family: Times New Roman;
	font-size: 11px;
	color: #000000; font-style: normal;
	background-color: transparent;
	border-left-color:#000000; border-left-style: solid; border-left-width: 1px;
	border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
	border-top-width: 0px;
	border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
	text-align: Center; vertical-align: Top;
	padding-top: 1px;
}
.s24 {
	/*font-family: Times New Roman;
	font-size: 11px;
	color: #000000; font-style: normal;*/
	background-color: transparent;
	border-left-width: 0px;
	border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
	border-top-width: 0px;
	border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
	text-align: Left; vertical-align: Top;
	padding-top: 1px;
	padding-left: 2px;
}
.s25 {
	font-family: Times New Roman;
	font-size: 11px;
	color: #000000; font-style: normal;
	background-color: transparent;
	border-left-width: 0px;
	border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
	border-top-width: 0px;
	border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
	text-align: Center; vertical-align: Top;
	padding-top: 1px;
}
.s26 {
	font-family: Times New Roman;
	font-size: 11px;
	color: #000000; font-style: normal;
	background-color: transparent;
	border-left-width: 0px;
	border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
	border-top-width: 0px;
	border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
	text-align: Right; vertical-align: Top;
	padding-top: 1px;
	padding-right: 2px;
}
.s27 {
	font-family: Times New Roman;
	font-size: 11px;
	color: #FFFFFF; font-style: normal;
	background-color: transparent;
	border-left-color:#000000; border-left-style: solid; border-left-width: 1px;
	border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
	border-top-width: 0px;
	border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
	text-align: Center; vertical-align: Top;
	padding-top: 1px;
}
.s28 {
	font-family: Times New Roman;
	font-size: 11px;
	color: #000000; font-weight: bold; font-style: normal;
	background-color: transparent;
	border-left-width: 0px;
	border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
	border-top-width: 0px;
	border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
	text-align: Left; vertical-align: Top;
	padding-top: 1px;
	padding-left: 2px;
}
.s29 {
	font-family: Times New Roman;
	font-size: 11px;
	color: #000000; font-weight: bold; font-style: normal;
	background-color: transparent;
	border-left-width: 0px;
	border-right-color:#000000; border-right-style: solid; border-right-width: 1px;
	border-top-width: 0px;
	border-bottom-color:#000000; border-bottom-style: solid; border-bottom-width: 1px;
	text-align: Right; vertical-align: Top;
	padding-top: 1px;
	padding-right: 2px;
}
P {margin: 0;}
/*td {*/
/*	border-color: blue;*/
/*	border-width: 1px;*/
/*}*/
.page {
	background-color: white;
	border-color: black;
	border-style: solid;
	border-width: 1px;
	width: 720px;
	margin-left: auto;
	margin-right: auto;
	padding: 20px;
	/*box-shadow: 5px 5px gray;*/
}

*, ::before, ::after {
  box-sizing: unset !important;
}

</style>
